export default __webpack_public_path__ + "static/media/18.07975f24.png";